import { logEvent } from '@amplitude/analytics-browser';
import { datadogRum } from '@datadog/browser-rum';
import { addBreadcrumb } from '@sentry/react';
import { TitleCase } from '@x1/util-format';
import { HypenCase } from '@x1/util-format';
import { redact } from '@x1/util-logging';

import { Event } from './events';
import { Domain, fetch } from 'src/clients/Network/http/fetch';
import { TrackingStore } from 'src/state/trackingStore';

interface TrackingIface {
  event: Event | string;
  screen?: string;
  value?: { [key: string]: any };
}

const log = async (event: string, value: {}) => {
  await fetch(Domain.RHCreditCard, '/log', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      action: event,
      details: value,
    }),
  });
};

const _track = async ({ event, value = {}, screen }: TrackingIface): Promise<void> => {
  const data = {
    event,
    value: Object.keys(value).length > 0 ? redact(JSON.stringify(value)) : undefined,
    screen,
  };
  addBreadcrumb({ data, level: 'debug' });
  const casedEvent = event.replace(/[/-]/g, ' ').split(' ').map(TitleCase).join('');
  await Promise.all([logEvent(casedEvent, data), datadogRum.addAction(casedEvent, data), log(casedEvent, value)]);
};

interface Value {}

export const trackPageView = async (screen: string, params?: Value): Promise<void> => {
  _track({ event: `view-${HypenCase(screen)}-screen`, value: { routeParams: params } });
  TrackingStore.setState({ screen });
};

export const track = async (event: Event, value?: Value): Promise<void> => {
  const { screen } = TrackingStore.getState();
  _track({ event, screen, value });
};

export { Event };
